var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanBeIrrigated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CAN_BE_IRRIGATED",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #CAN_BE_IRRIGATED .cls-1 {\n        fill: #f5f5f5;\n      }\n\n      #CAN_BE_IRRIGATED .cls-2 {\n        fill: #00c4ff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_127",
    "data-name": "Pfad 127",
    className: "cls-1",
    d: "M24.9,20.5a3,3,0,0,1-6,0c0-1.7,3-5.9,3-5.9S24.9,18.9,24.9,20.5Zm-1.6-1a.8.8,0,1,0,.8.8A.86.86,0,0,0,23.3,19.5Zm-10.4,1a2.946,2.946,0,0,1-3,3,2.946,2.946,0,0,1-3-3c0-1.7,3-5.9,3-5.9S12.9,18.9,12.9,20.5Zm-1.7-1a.8.8,0,1,0,.8.8A.789.789,0,0,0,11.2,19.5ZM19,11.4a3,3,0,0,1-6,0c0-1.7,3-5.9,3-5.9S19,9.7,19,11.4Zm-1.7-1a.8.8,0,0,0,0,1.6.736.736,0,0,0,.8-.8A.789.789,0,0,0,17.3,10.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_128",
    "data-name": "Pfad 128",
    className: "cls-2",
    d: "M16,2A14,14,0,1,1,2,16,14.041,14.041,0,0,1,16,2m0-2A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanBeIrrigated);
export default __webpack_public_path__ + "static/media/can-be-irrigated.21d97e2d2257de246203c6ccc1b5e9be.svg";
export { ForwardRef as ReactComponent };